import styles from "./styles.module.css";
import { useParams } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { db, functions } from "../../../firebase";
import { TypesValue } from "../../../contexts/types";
import useWebhookTypes from "../../../utils/usewebhooktypes";
import Config from "./config";
import usePan from "../../canvas/workflows/usepan";
import Actions from "./actions";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
const storeApiConnection = functions.httpsCallable("storeApiConnection");
export default function Webhooks({ webhook, setHook }) {
  const { appId } = useParams();
  const types = useContext(TypesValue);
  const hookTypes = useWebhookTypes(webhook);
  const [zoom, setZoom] = useState(1);
  const [offset, startPan] = usePan();

  const increase = () => {
    setZoom(zoom + 0.05);
  };

  const decrease = () => {
    setZoom(zoom - 0.05);
  };

  const handleSave = (_hook) => {
    db.collection("apps")
      .doc(appId)
      .collection("webhooks")
      .doc(webhook.id)
      .set(_hook);
  };

  const handleUpdate = (hook) => {
    console.log(hook);
    setHook(hook);
    handleSave(hook);
    storeApiConnection({ api: hook, version: "development", appId });
  };
  return (
    <DndProvider backend={HTML5Backend}>
      <TypesValue.Provider value={[...types, ...hookTypes]}>
        <div className={styles.canvas}>
          <div onMouseDown={startPan} className={styles.content}>
            <Config setHook={handleUpdate} webhook={webhook} appId={appId} />
            <Actions
              setHook={handleUpdate}
              webhook={webhook}
              zoom={zoom}
              offset={offset}
            />
            <div style={{ position: "absolute", left: 15, bottom: 15 }}>
              <button className={styles.zoomButton} onClick={increase}>
                +
              </button>
              <button className={styles.zoomButton} onClick={decrease}>
                -
              </button>
            </div>
          </div>
        </div>
      </TypesValue.Provider>
    </DndProvider>
  );
}
